import { render } from "./itemsList.vue?vue&type=template&id=5ea56b80&scoped=true"
import script from "./itemsList.vue?vue&type=script&lang=js"
export * from "./itemsList.vue?vue&type=script&lang=js"

import "./itemsList.vue?vue&type=style&index=0&id=5ea56b80&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea56b80"]])

export default __exports__